export default {
  name: 'light',
  fontColor: '#555555',
  secondaryFontColor: '#4E516C',
  lightFontColor: '#fff',
  purple: '#6D5BD0',
  loadingTableColor: '#ccc',
  loadingTableColorLight: '#d0d1db',
  componentborder: '#A2ADB5',
  background: '#efefef',
  cardBackgroud: '#ffffff',
  cardBorder: 'none',

  error: '#f5365c',
  success: '#00bf9a',
  info: '#106EBE',
  warn: '#ff9f89',
  attention: '#ecc66e',
  backgroundSecondary: '#A1A1A1',
  playerControls: '#4e86ff',
  hover: '#eaeaea',
  selectedPage: '#072F51',
  skeleton: {
    color: '#f2f2f2',
    highlight: '#ccc',
  },
  menu: {
    fontColor: '#1d253b',
    in: '#4e86ff',
    out: '#3b6cf2',
  },
  tooltip: {
    background: '#f2f2f2',
    fontColor: '#555555',
  },
  switch: {
    background: '#aeaeae',
    checkedbackground: '#8ae6a1',
  },
  checkbox: {
    selected: '#353B3F',
    notselected: '#73818C',
  },
  select: {
    selected: '#3358f4',
    new: '#4E516C',
  },
  table: {
    header: '#3788d8',
    fontColor: '#717171',
  },
  notification: {
    new: '#F06D6D',
    empty: '#eee',
  },
  badge: {
    unselected: '#979797',
    selected: '#3358f4',
  },
  graph: {
    graphAxis: '#A1A1A1',
    semplanilha: '#3D92DB',
    naogravados: '#F06D6D',
    naoconferidos: '#ecc66e',
    pendentes: '#e6978a',
    disponiveiseng: '#3D92DB',
    gravados: '#02D2B6',
    conferidos: '#07C961',
    aprovado: '#07C961',
    reprovado: '#C94F5C',
    ressalva: '#ffd472',
  },

  datepicker: {
    selected: '#0074d9',
    today: '#ccc',
  },

  timeline: {
    bar: '#dddddd',
    balloon: '#dae9ff',
  },
  button: {
    default: {
      in: '#3358f4',
      out: '#1D8CF8',
      text: '#1D8CF8',
    },
    primary: {
      in: '#3358f4',
      out: '#1D8CF8',
      text: '#1D8CF8',
    },
    secondary: {
      in: '#ba54f5',
      out: '#e14eca',
    },
    // done: {
    //   in: '#186869',
    //   out: '#009677',
    // },
    done: {
      in: '#007f96',
      out: '#00e6e9',
    },
    // done: {
    //   in: '#c5e900',
    //   out: '#2f9600',
    // },
    success: {
      in: '#07C961',
      out: '#27a93c',
    },
    warn: {
      in: '#ffd472',
      out: '#ff8a72',
    },
    danger: {
      in: '#f5365c',
      out: '#EC250D',
    },
    flag: {
      in: '#ffffff',
      out: '#979797',
    },
  },

  calendar: {
    chamada: '#91fd9f',
    vinheta: '#87CEFA',
    promocional: '#F57C00',
    chpatrocinada: '#C94F5C',
    apoio: '#FFC107',
    campanha: '#E91E63',
    campanhapatrocinada: '#795548',
    videopatrocinado: '#7C4DFF',
    programete: '#4E516C',
    afinacao: '#ba54f5',
    multiploformato: '#4DA262', // Orientações Exibição
  },

  daytime: {
    manha: '#ffc182',
    tarde: '#ffda6c',
    noite: '#abd8ff',
  },

  flag: {
    indisponivel: '#979797',
    nao_autorizado: '#979797',
    sem_planilha: '#979797',
    inativo: '#979797',
    noclosedcaption: '#979797',
    exibrede: '#979797',
    fade: '#979797',
    semCC: '#979797',
    semweb: '#979797',
    NA: '#979797',
    arquivado: '#979797',
    autotranscrever: '#3D92DB',
    pendente: '#3D92DB',
    fila_download: '#3D92DB',
    baixando: '#3D92DB',
    emAndamento: '#3D92DB',
    emprocesso: '#3D92DB',
    processando: '#3D92DB',
    avaliacao_eng: '#3D92DB',
    fila_envio: '#3D92DB',
    resetar_senha: '#3D92DB',
    convertendo: '#3D92DB',
    cadastrando: '#3D92DB',
    enviando_exibidor: '#3D92DB',
    enviadaVI: '#3D92DB',
    analisando: '#3D92DB',
    solicitado: '#3D92DB',
    autorizado: '#3D92DB',
    gravado: '#4DA262',
    conferido: '#4DA262',
    processado: '#4DA262',
    aprovado: '#4DA262',
    ingest_manual: '#4DA262',
    ativo: '#4DA262',
    convertido: '#4DA262',
    cadastrado: '#4DA262',
    closedcaption: '#4DA262',
    cadastrada: '#4DA262',
    encapsulada: '#4DA262',
    editada: '#4DA262',
    finalizado: '#4DA262',
    analisado: '#4DA262',
    entregue: '#4DA262',
    ressalva: '#ffd472',
    aprovacao: '#ffd472',
    reprovado_eng: '#F06D6D',
    reprovado: '#F06D6D',
    error: '#F06D6D',
    erro: '#F06D6D',
    erro_envio: '#F06D6D',
    erroconversao: '#F06D6D',
    errocadastro: '#F06D6D',
    alteracao: '#F06D6D',
    naogravado: '#F06D6D',
    reenvio: '#ba54f5',
    edicao: '#ba54f5',
    entreguech: '#007f96',
    // Tipos de Comerciais
    comercial: '#3D92DB',
    base: '#FFC107',
    patrocinio: '#FFC107',
    // Tipos de Chamadas
    chamada: '#58a45c',
    vinheta: '#4d6fff',
    promocional: '#F57C00',
    chpatrocinada: '#C94F5C',
    apoio: '#ffd147',
    campanha: '#E91E63',
    campanhapatrocinada: '#795548',
    videopatrocinado: '#7C4DFF',
    programete: '#4E516C',
    afinacao: '#ba54f5',
    // Tipos de Midias
    chjorn: '#388E3C',
    rede: '#4d6fff',
    pgrede: '#4d6fff',
    blocopolitico: '#ba54f5',
    optativo: '#F57C00',
    // Setores
    programacao: '#ff8a72',
    jornalismo: '#388E3C',
    cedoc: '#ff8a72',
    marketing: '#ff8a72',
    opec: '#3D92DB',
    promo: '#ba54f5',
    hub: '#ba54f5',
    engenharia: '#ffd472',
    // Tipos de Solicitações de Chamadas
    especiais: '#4d6fff',
    pgmlinha: '#ba54f5',
    // Tipos de Solicitações Digital
    g1: '#C94F5C',
    especial: '#ffd147',
    exclusivo: '#ba54f5',
    evento: '#4d6fff',
    // Notificação Melhoria do Break
    insight: '#ffd147',
    alerta: '#C94F5C',
    //Telões
    padrao: '#388E3C',
    novacriacao: '#ba54f5',
    outroformato: '#4d6fff',
    unico: '#FFC107',
    menor: '#007f96',
    maior: '#2B88D8',
  },
  // flag: {
  //   disabled: '#979797',
  //   processing: '#3D92DB',
  //   ok: '#4DA262',
  //   warn: '#ffd472',
  //   error: '#F06D6D',
  //   purple: '#ba54f5',
  //   yellow: '#FFC107',
  //   // Tipos de Chamadas
  //   chamada: '#388E3C',
  //   vinheta: '#3358f4',
  //   promocional: '#F57C00',
  //   chpatrocinada: '#C94F5C',
  //   apoio: '#FFC107',
  //   campanha: '#E91E63',
  //   campanhapatrocinada: '#795548',
  //   videopatrocinado: '#7C4DFF',
  //   programete: '#4E516C',
  //   // Tipos de Midias
  //   chjorn: '#388E3C',
  //   rede: '#4d6fff',
  //   pgrede: '#4d6fff',
  //   blocopolitico: '#ba54f5',
  //   optativo: '#F57C00',
  //   // Setores
  //   programacao: '#ff8a72',
  //   jornalismo: '#ff8a72',
  //   cedoc: '#ff8a72',
  //   marketing: '#ff8a72',
  // },
};
